import { styled } from '@mui/material';
import { SPACES } from '../../../constants/sizes';

const calcProviderBoxesWrapping = (providersLength = 0) => {
  if (providersLength <= 5) {
    return '';
  }
  return '25rem';
};

interface StyledProviderBoxesViewProps {
  providers: Record<string, unknown>;
}

const StyledProviderBoxesView = styled('div')<StyledProviderBoxesViewProps>`
  display: flex;
  justify-content: center;
  max-width: ${({ providers }) =>
    calcProviderBoxesWrapping(Object.keys(providers).length)};
  flex-wrap: wrap;
  margin-top: ${SPACES['medium']};
`;

export default StyledProviderBoxesView;
